import {useEffect,useState} from 'react';
import type {SmmRuntimePort} from './product-types';
import type {MobileBusinessDayReceipts,MobileCashReceipt} from '../../../contracts/mobile-business-day-v1';

const time=(value:string)=>new Date(value).toLocaleString('zh-HK',{hour12:false});
function Receipt({label,value}:{label:string;value:MobileCashReceipt}){
  const status=value.state==='AVAILABLE'?'已收到':value.state==='NOT_RECEIVED'?'未收到':value.state==='SOURCE_UNCONFIRMED'?'來源待確認':'舊來源未確認';
  return <section className="smm-print-health"><div className="list-row"><strong>{label}</strong><span className={'status '+(value.state==='AVAILABLE'?'positive':'unknown')}>{status}</span></div>
    {value.occurredAt?<small>紀錄時間：{time(value.occurredAt)}</small>:null}
    {value.state==='NOT_RECEIVED'?<p>未收到此營業日嘅紀錄；如已在 Pad 完成，請核對同步。</p>:value.state!=='AVAILABLE'?<p>已保存紀錄，但來源未能確認，請在 Pad 核對。</p>:null}
  </section>;
}
export function BusinessDayReceipts({read}:{read:NonNullable<SmmRuntimePort['readBusinessDay']>}){
  const [data,setData]=useState<MobileBusinessDayReceipts|null>(null),[busy,setBusy]=useState(false),[error,setError]=useState<string|null>(null);
  const load=async()=>{if(busy)return;setBusy(true);setError(null);try{setData(await read());}catch(reason){setError(reason instanceof Error&&reason.message==='請重新登入員工帳戶。'?reason.message:'暫時未能讀取營業日記錄；以下為上次讀回資料。');}finally{setBusy(false);}};
  useEffect(()=>{void load();},[read]);
  return <>
    <button className="primary smm-more-read" disabled={busy} onClick={()=>void load()}>{busy?'讀取中…':'重新讀取'}</button>
    {error?<p className="callout" role="alert">{data?error:error==='請重新登入員工帳戶。'?error:'暫時未能讀取營業日記錄，請重新讀取。'}</p>:null}
    {data?<><div className="metric-grid"><div className="metric"><small>營業日</small><strong>{data.businessDate}</strong></div></div>
      <Receipt label="開櫃記錄" value={data.opening}/><Receipt label="日結封存記錄" value={data.dayClose}/>
      <p className="callout">開櫃及日結封存請在 Pad 完成。</p><small>讀取於 {time(data.observedAt)}</small>
    </>:busy?<p role="status">正在讀取營業日記錄…</p>:null}
  </>;
}
